<button
  type="button"
  nz-button
  nzType="link"
  (click)="download()"
  [attr.aria-label]="text || 'CSV herunterladen'"
  nz-tooltip
  nzTooltipTitle="CSV herunterladen"
>
  @if (text) {
    <span>{{ text }}</span>
  }
  <i
    nz-icon
    nzType="{{ icon }}"
    nzTheme="outline"
  ></i>
</button>
